import { VoteType } from '@notino/shared/__generated__/globalSPATypes';

import { getReviews_reviews } from '../../queries/__generated__/getReviews';

export const canBeVoted = (review: getReviews_reviews, likeDislike: string) =>
  (!review.alreadyLiked && !review.alreadyDisliked) ||
  (review.alreadyLiked && likeDislike === VoteType.like) ||
  (review.alreadyDisliked && likeDislike === VoteType.dislike);
